"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfFacilityNurseDto = instanceOfFacilityNurseDto;
exports.FacilityNurseDtoFromJSON = FacilityNurseDtoFromJSON;
exports.FacilityNurseDtoFromJSONTyped = FacilityNurseDtoFromJSONTyped;
exports.FacilityNurseDtoToJSON = FacilityNurseDtoToJSON;
exports.FacilityNurseDtoToJSONTyped = FacilityNurseDtoToJSONTyped;
const NurseSpecialtyDto_1 = require("./NurseSpecialtyDto");
const FacilityNurseBlockReason_1 = require("./FacilityNurseBlockReason");
/**
 * Check if a given object implements the FacilityNurseDto interface.
 */
function instanceOfFacilityNurseDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('firstName' in value) || value['firstName'] === undefined)
        return false;
    if (!('lastName' in value) || value['lastName'] === undefined)
        return false;
    if (!('email' in value) || value['email'] === undefined)
        return false;
    if (!('verifiedFacilities' in value) || value['verifiedFacilities'] === undefined)
        return false;
    if (!('blockedAt' in value) || value['blockedAt'] === undefined)
        return false;
    if (!('blockedBy' in value) || value['blockedBy'] === undefined)
        return false;
    if (!('specialties' in value) || value['specialties'] === undefined)
        return false;
    if (!('avatar' in value) || value['avatar'] === undefined)
        return false;
    return true;
}
function FacilityNurseDtoFromJSON(json) {
    return FacilityNurseDtoFromJSONTyped(json, false);
}
function FacilityNurseDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'email': json['email'],
        'verifiedFacilities': json['verifiedFacilities'],
        'phoneNumber': json['phoneNumber'] == null ? undefined : json['phoneNumber'],
        'blockedAt': (json['blockedAt'] == null ? null : new Date(json['blockedAt'])),
        'blockedBy': json['blockedBy'],
        'reason': json['reason'] == null ? undefined : (0, FacilityNurseBlockReason_1.FacilityNurseBlockReasonFromJSON)(json['reason']),
        'specialties': (json['specialties'].map(NurseSpecialtyDto_1.NurseSpecialtyDtoFromJSON)),
        'avatar': json['avatar'],
    };
}
function FacilityNurseDtoToJSON(json) {
    return FacilityNurseDtoToJSONTyped(json, false);
}
function FacilityNurseDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'email': value['email'],
        'verifiedFacilities': value['verifiedFacilities'],
        'phoneNumber': value['phoneNumber'],
        'blockedAt': (value['blockedAt'] == null ? null : value['blockedAt'].toISOString().substring(0, 10)),
        'blockedBy': value['blockedBy'],
        'reason': (0, FacilityNurseBlockReason_1.FacilityNurseBlockReasonToJSON)(value['reason']),
        'specialties': (value['specialties'].map(NurseSpecialtyDto_1.NurseSpecialtyDtoToJSON)),
        'avatar': value['avatar'],
    };
}
//# sourceMappingURL=FacilityNurseDto.js.map